import { DeskDocument } from 'client/api/backend/schemas';
import { ToolkitObject } from 'client/components/toolkit/objects/ToolkitObject';

export function canDocumentBeSentToQueue(
  document: ToolkitObject<DeskDocument>
) {
  return document.data.protocolNumber == null && document.data.mode == null;
}
